module.exports = __webpack_public_path__ + "img/welcome_doorbell.529a88d3.png";